export default "__VITE_ASSET__BCigTAF1__$_?format=webp__"